exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buildingBox[data-v-e91806c6]{display:flex;flex-wrap:wrap}.playerStateDisplay[data-v-e91806c6]{margin:.5rem 0;padding:.3rem;box-sizing:border-box}.mr-1rem[data-v-e91806c6]{margin-right:1rem}.playerStateDisplay svg[data-v-e91806c6]{margin-right:.5em}", ""]);

// exports
